// ==========================================
// サイト内JavaScript 統合管理コード
// ==========================================

// タイマー（setInterval）の重複防止用変数
let topImageInterval = null;
let flowInterval = null;

// 画面表示・Turbo遷移時に各機能を初期化
const initAllScripts = () => {
  // 既存のタイマーをリセット（重複動作防止）
  if (topImageInterval) clearInterval(topImageInterval);
  if (flowInterval) clearInterval(flowInterval);

  initToc();
  initContactButton();
  initTopImageSlider();
  initMonthlyDetails();
  initFlowSteps();
  initHamburgerMenu();
};

document.addEventListener("turbo:load", initAllScripts);
document.addEventListener("turbolinks:load", initAllScripts);
document.addEventListener("DOMContentLoaded", initAllScripts);

// 1. 目次自動生成 (.post-content, #toc-list)
function initToc() {
  const content = document.querySelector('.post-content');
  const tocList = document.getElementById('toc-list');
  if (!content || !tocList) return;

  tocList.innerHTML = ''; // Turbo遷移時の重複追加防止
  const headings = content.querySelectorAll('h2');
  headings.forEach((heading, index) => {
    const id = 'heading-' + index;
    heading.setAttribute('id', id);

    const li = document.createElement('li');
    const a = document.createElement('a');
    a.textContent = heading.textContent;
    a.href = '#' + id;
    a.style.textDecoration = 'none';
    a.style.color = '#007bff';

    li.appendChild(a);
    li.style.marginBottom = '8px';
    tocList.appendChild(li);
  });
}

// 2. お問い合わせボタンのスクロール表示制御 (#contactButtonContainer)
function initContactButton() {
  const contactButtonContainer = document.getElementById('contactButtonContainer');
  if (!contactButtonContainer) return;

  const threshold = 5;
  function toggleContactButtonVisibility() {
    const documentHeight = document.documentElement.scrollHeight;
    const viewportHeight = window.innerHeight;
    const scrollPosition = window.scrollY;
    const isAtBottom = (scrollPosition + viewportHeight >= documentHeight - threshold);

    if (window.innerWidth < 768) {
      if (isAtBottom) {
        contactButtonContainer.classList.add('hidden');
      } else {
        contactButtonContainer.classList.remove('hidden');
      }
    } else {
      contactButtonContainer.classList.add('hidden');
    }
  }

  window.removeEventListener('scroll', toggleContactButtonVisibility);
  window.removeEventListener('resize', toggleContactButtonVisibility);
  window.addEventListener('scroll', toggleContactButtonVisibility);
  window.addEventListener('resize', toggleContactButtonVisibility);
  toggleContactButtonVisibility();
}

// 3. トップ画像スライダー (#topImageSection)
function initTopImageSlider() {
  const topImageSection = document.getElementById('topImageSection');
  if (!topImageSection) return;

  const backgroundImages = topImageSection.querySelectorAll('.top-image-background-img');
  if (!backgroundImages.length) return;

  let currentIndex = 0;
  const activeImage = topImageSection.querySelector('.top-image-background-img.is-active');
  if (activeImage) {
    currentIndex = Array.from(backgroundImages).indexOf(activeImage);
    if (currentIndex === -1) currentIndex = 0;
  } else {
    backgroundImages[0].classList.add('is-active');
  }

  function changeImage() {
    const currentActive = topImageSection.querySelector('.top-image-background-img.is-active');
    if (currentActive) currentActive.classList.remove('is-active');
    currentIndex = (currentIndex + 1) % backgroundImages.length;
    backgroundImages[currentIndex].classList.add('is-active');
  }

  topImageInterval = setInterval(changeImage, 5000);
}

// 4. 月別コンテンツ切り替え (.month-circle)
function initMonthlyDetails() {
  const monthCircles = document.querySelectorAll('.month-circle');
  const monthlyDetails = document.querySelectorAll('.monthly-detail-content');
  if (!monthCircles.length || !monthlyDetails.length) return;

  monthCircles.forEach(circle => {
    circle.addEventListener('click', function() {
      const selectedMonth = this.dataset.month;
      monthlyDetails.forEach(detail => detail.classList.remove('is-active'));
      monthCircles.forEach(c => c.classList.remove('is-active'));

      const targetDetail = document.querySelector(`.monthly-detail-content[data-month="${selectedMonth}"]`);
      if (targetDetail) targetDetail.classList.add('is-active');
      this.classList.add('is-active');
    });
  });
}

// 5. フローの自動・手動切り替え (.flow-step-item)
function initFlowSteps() {
  const flowSteps = document.querySelectorAll('.flow-step-item');
  const flowDetails = document.querySelectorAll('.flow-detail-content');
  if (!flowSteps.length || !flowDetails.length) return;

  let currentIndex = 0;
  flowDetails.forEach(detail => detail.classList.remove('is-active'));
  flowSteps.forEach(step => step.classList.remove('is-active'));
  
  if (flowDetails[0]) flowDetails[0].classList.add('is-active');
  if (flowSteps[0]) flowSteps[0].classList.add('is-active');

  function showNextContent() {
    if (!flowDetails[currentIndex] || !flowSteps[currentIndex]) return;
    flowDetails[currentIndex].classList.remove('is-active');
    flowSteps[currentIndex].classList.remove('is-active');
    
    currentIndex = (currentIndex + 1) % flowDetails.length;
    
    if (flowDetails[currentIndex]) flowDetails[currentIndex].classList.add('is-active');
    if (flowSteps[currentIndex]) flowSteps[currentIndex].classList.add('is-active');
  }

  flowInterval = setInterval(showNextContent, 3000);

  flowSteps.forEach(step => {
    step.addEventListener('click', function() {
      if (flowInterval) clearInterval(flowInterval);
      const stepNumber = parseInt(this.dataset.step);
      const targetIndex = stepNumber - 1;

      flowDetails.forEach(detail => detail.classList.remove('is-active'));
      flowSteps.forEach(item => item.classList.remove('is-active'));

      if (flowDetails[targetIndex]) {
        flowDetails[targetIndex].classList.add('is-active');
        this.classList.add('is-active');
        currentIndex = targetIndex;
      }
    });
  });
}

// 6. ハンバーガーメニュー (.hamburger, .nav)
function initHamburgerMenu() {
  const hamburger = document.querySelector('.hamburger');
  const nav = document.querySelector('.nav');
  const servicesLink = document.querySelector('.services-link');
  const hasSubmenuItem = document.querySelector('.nav__item.has-submenu');

  if (!hamburger || !nav) return;

  hamburger.onclick = () => {
    hamburger.classList.toggle('active');
    nav.classList.toggle('active');

    const isOpen = hamburger.classList.contains('active');
    hamburger.setAttribute('aria-expanded', isOpen);
    nav.setAttribute('aria-hidden', !isOpen);

    if (servicesLink && hasSubmenuItem) {
      if (isOpen) {
        servicesLink.setAttribute('aria-expanded', 'true');
        hasSubmenuItem.classList.add('active');
      } else {
        servicesLink.setAttribute('aria-expanded', 'false');
        hasSubmenuItem.classList.remove('active');
      }
    }
  };

  if (servicesLink && hasSubmenuItem) {
    servicesLink.onclick = (e) => {
      if (!nav.classList.contains('active')) {
        e.preventDefault();
        const isExpanded = servicesLink.getAttribute('aria-expanded') === 'true';
        servicesLink.setAttribute('aria-expanded', !isExpanded);
        hasSubmenuItem.classList.toggle('active');
      }
    };
  }
}

// 7. クリックイベントデリゲーション（タブ切り替え・FAQアコーディオン・外側クリック判定）
document.addEventListener("click", (e) => {
  // A. サービス一覧タブ切り替え
  const tabBtn = e.target.closest(".works-tab-nav .tab-btn");
  if (tabBtn) {
    const nav = tabBtn.closest(".works-tab-nav");
    const sec = tabBtn.closest(".works-sec");
    if (!nav || !sec) return;

    nav.querySelectorAll(".tab-btn").forEach((b) => b.classList.remove("active"));
    tabBtn.classList.add("active");

    const targetSelector = tabBtn.getAttribute("data-tab-target");
    sec.querySelectorAll(".tab-content").forEach((c) => c.classList.remove("active"));

    if (targetSelector) {
      const targetContent = sec.querySelector(targetSelector);
      if (targetContent) targetContent.classList.add("active");
    }
    return;
  }

  // B. 汎用FAQアコーディオン
  const faqBtn = e.target.closest(".faq-question");
  if (faqBtn) {
    const answer = faqBtn.nextElementSibling;
    if (!answer) return;
    const isOpen = answer.style.display === "block";

    document.querySelectorAll(".faq-answer").forEach((ans) => {
      ans.style.display = "none";
    });

    if (!isOpen) answer.style.display = "block";
    return;
  }

  // C. 草むしりFAQアコーディオン
  const weedingFaqBtn = e.target.closest(".weeding-faq-question");
  if (weedingFaqBtn) {
    const answer = weedingFaqBtn.nextElementSibling;
    if (!answer) return;
    const isOpen = answer.style.display === "block";

    document.querySelectorAll(".weeding-faq-answer").forEach((ans) => {
      ans.style.display = "none";
    });

    if (!isOpen) answer.style.display = "block";
    return;
  }

  // D. ハンバーガーメニュー / サブメニューの外側クリックで閉じる処理
  const nav = document.querySelector('.nav');
  const hamburger = document.querySelector('.hamburger');
  const servicesLink = document.querySelector('.services-link');
  const hasSubmenuItem = document.querySelector('.nav__item.has-submenu');

  if (nav && hamburger && nav.classList.contains('active')) {
    if (!e.target.closest('.nav') && !e.target.closest('.hamburger')) {
      hamburger.classList.remove('active');
      nav.classList.remove('active');
      hamburger.setAttribute('aria-expanded', 'false');
      nav.setAttribute('aria-hidden', 'true');
      if (servicesLink && hasSubmenuItem) {
        servicesLink.setAttribute('aria-expanded', 'false');
        hasSubmenuItem.classList.remove('active');
      }
    }
  } else if (hasSubmenuItem && servicesLink && hasSubmenuItem.classList.contains('active')) {
    if (!e.target.closest('.has-submenu')) {
      servicesLink.setAttribute('aria-expanded', 'false');
      hasSubmenuItem.classList.remove('active');
    }
  }
});